import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb3d4ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "All Tasks", -1))
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = {
  key: 1,
  class: "tasktablecontainer"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import TaskList from "@/components/TaskList.vue";
import { useEmployeeStore } from "@/stores/UserEmployee";
import { useTaskStore } from "@/stores/Tasks";
import { storeToRefs } from "pinia";
import { onMounted, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskListView',
  setup(__props) {

const userStore = useEmployeeStore();
const taskStore = useTaskStore();
const { all_tasks, isLoadingTaks } = storeToRefs(taskStore);
const { currentUser } = storeToRefs(userStore);

const greeting = computed(() => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
});

onMounted(() => {
  // console.log("component mounted");
  taskStore.getAllTasks();
});

watch(all_tasks, (newTasks) => {
  if (newTasks) {
    // You can perform additional actions here if needed,
    // such as logging or handling the data differently.
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(greeting.value) + ", " + _toDisplayString(_unref(currentUser)?.user.full_name), 1),
      _hoisted_3
    ]),
    (_unref(isLoadingTaks))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(currentUser)?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(TaskList, {
                  tasks: _unref(all_tasks),
                  visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'labor_cost', 'assigned', 'actions']
                }, null, 8, ["tasks"])
              ]))
            : _createCommentVNode("", true),
          (_unref(currentUser)?.user.is_staff && !_unref(currentUser)?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(TaskList, {
                  tasks: _unref(all_tasks),
                  visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'assigned', 'actions']
                }, null, 8, ["tasks"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})